import { BUSINESS_ROLE_GROUPS } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';
import { RouteObject } from 'react-router-dom';
import { Authorize } from '@/components';
import { lazy } from 'react';

const Drivers = lazy(() => import('../Drivers'));
const ViewDriver = lazy(() => import('../pages/ViewDriver/ViewDriver'));
const EditDriver = lazy(() => import('../pages/EditDriver/EditDriver'));

const DRIVER_MANAGEMENT_PERMISSIONS = BUSINESS_ROLE_GROUPS.operations;

const DriversRoutes: RouteObject[] = [
  {
    path: 'drivers',
    element: <Drivers />,
  },
  {
    path: 'drivers/:driverId',
    element: (
      <Authorize
        permission={DRIVER_MANAGEMENT_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <ViewDriver />
      </Authorize>
    ),
  },
  {
    path: 'drivers/:driverId/edit',
    element: (
      <Authorize
        permission={DRIVER_MANAGEMENT_PERMISSIONS}
        fallback={<ErrorPage code={403} />}
      >
        <EditDriver />
      </Authorize>
    ),
  },
];

export default DriversRoutes;
